/* Plugin to cache *selected* mutations */

import modelCache from "@/services/modelCache.service";

const mutationsMap = {
  "records/setItems": "items",
  "records/setItemDetail": "items",
  "records/setRecord": "records"
};

const shouldCache = mutation => {
  // Cache all mutations of the type included in the whitelist
  if (Object.keys(mutationsMap).includes(mutation.type)) {
    return true;
  }
  return false;
};

const plugin = store => {
  store.subscribe(mutation => {
    if (shouldCache(mutation)) {
      let modelName = mutationsMap[mutation.type];
      let key = mutation.payload.id; // Defined to overwrite later if needed
      var data = {};
      // Handle business logic for each case
      let val = mutation.type;
      switch (val) {
        case "records/setItems":
          data = mutation.payload.data;
          break;
        case "records/setItemDetail":
          var items = modelCache.get("items", mutation.payload.record);
          var idx = items.findIndex(i => i.id == mutation.payload.id);
          items[idx] = mutation.payload;
          data = items;
          key = mutation.payload.record;
          break;
        default:
          data = mutation.payload;
          break;
      }
      modelCache.set(modelName, key, data);
    }
  });
};

export default plugin;
